module.exports = __webpack_public_path__ + "static/media/icon_wheat_plus_one_3.d46ff841.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/game/textures/icon_wheat_plus_one_3.png
 ** module id = 620
 ** module chunks = 0
 **/